import moment from "moment";
import React, { useState } from "react";
import { Button, Col, Container, Nav, Row, Tab } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import dataHandler from "../../../../hooks/dataHandler";
import { CANCELBOOKING } from "../../../../services/ApiCalls";
import TableActions from "../../../../components/Common/TableActions";
import CountryFilter from "../../../../components/Common/CountryFilter";
import { bookingStatusUpcomming } from "../../../../utilities/const";
import Filter from "../../../../components/Common/Filter";
import { exportCsvHandler } from "../../../../utilities/utilities";
import ButtonLoader from "../../../../components/Common/ButtonLoader";
import TableLayout from "../../../../components/TableLayout";
import CustomPagination from "../../../../components/Common/CustomPagination";
import { useTranslation } from "react-i18next";

const CancelOrder = () => {
  const { t } = useTranslation();
  const [userDetails, setUserUserDetails] = useState();
  const [exportLoader, setExportLoader] = useState();
  const [deleteModal, setDeleteModel] = useState();
  const {
    setBody,
    body,
    data,
    loader,
    paginationHandler,
    searchHandler,
    total,
  } = dataHandler({
    api: CANCELBOOKING,
  });
  const { id } = useParams();
  const column = [
    {
      head: t("bookingUpcoming.table.srNo"),
      accessor: "#",
      component: (item, key) => <>{key + 1}</>,
    },
    {
      head: t("bookingUpcoming.table.bookingId"),
      accessor: "bookingId",
      component: (item) => (
        <span className="d-block text-truncate">
          {item?.bookingDetail?.bookingId || "-"}
        </span>
      ),
    },
    // {
    //   head: "Booking Type",
    //   accessor: "bookingType",
    //   component: (item) => <>{item?.bookingType || "-"}</>,
    // },
    {
      head: t("bookingUpcoming.table.price"),
      accessor: "price",
      component: (item) =>
        item?.bookingDetail?.price
          ? `${item?.bookingDetail?.hotelDetail?.currencySymbol || ""}${item.bookingDetail.price
          }`
          : "--",
    },
    {
      head: t("bookingUpcoming.table.hotelName"),
      accessor: "hotelName",
      component: (item) => (
        <span className="d-block text-truncate">
          {item?.bookingDetail?.hotelDetail?.hotelName || "-"}
        </span>
      ),
    },
    {
      head: t("bookingUpcoming.table.hotelId"),
      accessor: "hotelId",
      component: (item) => (
        <span className="d-block text-truncate">
          {item?.bookingDetail?.hotelDetail?.hotelId || "-"}
        </span>
      ),
    },
    {
      head: t("bookingUpcoming.table.paymentStatus"),
      accessor: "paymentStatus",
      component: (item) => (
        <span className="text-capitalize">
          {item?.bookingDetail?.paymentStatus || "-"}
        </span>
      ),
    },
    {
      head: t("bookingUpcoming.table.reason"),
      accessor: "reason",
      component: (item) => (
        <span className="d-block text-truncate">{item?.reason || "-"}</span>
      ),

    },
    {
      head: t("bookingUpcoming.table.userName"),
      accessor: "first_name",
      component: (item) => {
        const firstName = item?.customerDetail?.first_name || "";
        const lastName = item?.customerDetail?.last_name || "";
        const fullName = [firstName, lastName].filter(Boolean).join(" ");
        return <span className="d-block text-truncate">{fullName || "-"}</span>;
      },
    },
    {
      head: t("bookingUpcoming.table.dateTime"),
      accessor: "createdAt",
      component: (item) => (
        <span className="d-block text-truncate">
          {moment(item?.createdAt).format("MM-DD-YYYY , HH:mm A") || "-"}
        </span>
      ),
    },
    {
      head: t("bookingUpcoming.table.bookingStatus"),
      accessor: "bookingStatus",
      component: (item) => {
        const status = item?.status?.toLowerCase() || "-";

        const statusStyles = {
          pending: {
            backgroundColor: "#fff3cd",
            color: "#856404",
          },
          completed: {
            backgroundColor: "#d4edda",
            color: "#155724",
          },
          rejected: {
            backgroundColor: "#f8d7da",
            color: "#721c24",
          },
          cancelled: {
            backgroundColor: "#e2e3e5",
            color: "#383d41",
          },
        };

        const style = statusStyles[status] || {
          backgroundColor: "#f0f0f0",
          color: "#333",
        };

        return (
          <span
            style={{
              ...style,
              borderRadius: "12px",
              padding: "4px 10px",
              display: "inline-block",
              fontWeight: "600",
              fontSize: "0.85rem",
              textTransform: "capitalize",
            }}
          >
            {status}
          </span>
        );
      },
    },
    {
      head: t("bookingUpcoming.table.action"),
      accessor: "Action",
      component: (item) => (
        <TableActions viewLink={`/cancel-booking/${item._id}`} />
      ),
    },
  ];

  return (
    <>
      <section className="orderManagement position-relative py-2">
        <Container>
          <Row>
            <Col lg="12 ">
              <div className="d-flex  justify-content-between">
                <h4 className="mb-0 py-3 fw-bold text-dark text-capitalize">
                  {t("bookingUpcoming.cancel.title")}
                </h4>
                {/* <div className="d-flex align-items-center gap-2">
                  <label
                    htmlFor="countryFilter"
                    className="form-label m-0 fw-semibold text-muted"
                    style={{ whiteSpace: "nowrap" }}
                  >
                    Filter by Country
                  </label>
                  <CountryFilter
                    id="countryFilter"
                    body={body}
                    setBody={setBody}
                  />
                </div> */}
              </div>
            </Col>
            <Col lg="12" className="my-2">
              <div className="tableFilter d-flex align-items-center justify-content-between flex-wrap gap-10 mb-3">
                <div className="left">
                  <Filter
                    body={body}
                    setBody={setBody}
                    searchHandler={searchHandler}
                    // FilterPaidAndUnpaid={bookingStatusUpcomming}
                    type="booking"
                  />
                </div>

                <div className="right">
                  <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center gap-10 flex-wrap">
                    <li className="">
                      <Button
                        className="d-flex align-items-center justify-content-center fw-sbold commonBtn GreyBtn"
                        style={{ height: 40, minWidth: 100, fontSize: 12 }}
                        type="button"
                        onClick={() =>
                          exportCsvHandler("bookingCancellationCsv", setExportLoader)
                        }
                      >
                        {exportLoader ? <ButtonLoader /> : "Export CSV"}
                      </Button>
                    </li>
                  </ul>
                </div>
              </div>
            </Col>
            <Col lg="12" className="my-2">
              <div className="my-2">
                <Col lg="12" className="my-2">
                  <TableLayout column={column} data={data} loader={loader} />
                  <CustomPagination
                    total={total}
                    pageChangeHandler={paginationHandler}
                    body={body}
                    setBody={setBody}
                  />
                </Col>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default CancelOrder;
